import axios from 'axios';
import { storage } from '@/shared/plugins/storage';

const Endpoint = {
  ACTION: '',
  ADD: '/contactAdd',
  CREATE: '/contactAnonymousCreate',
  FIND: '/contactFind',
  MERGE: '/contactMerge',
};

const ContactType = {
  ANONYMOUS: 2,
  RECOGNIZED: 1,
};

export default class ReportingAdapter {
  constructor({ dataAuthorizationField, dataReportingField, idCustomer, appId, subscriber }) {
    this.idCustomer = idCustomer;
    this.contactPromise = Promise.resolve();
    this.apiClientIpresso = this.createApiClient(appId, dataAuthorizationField);
    this.apiClientDIIP = this.createApiClient(appId, dataReportingField, { withAuth: true });
    this.subscriber = subscriber;
  }

  get contact() {
    return storage.ipressoContact || {};
  }

  set contact(value) {
    storage.ipressoContact = value;
  }

  request(endpoint, data = {}) {
    const params = { ...data, idCustomer: this.idCustomer };
    const apiClient = endpoint === Endpoint.ACTION ? this.apiClientDIIP : this.apiClientIpresso;

    return apiClient.post(endpoint, params);
  }

  action(key, params = {}, opts = {}) {
    let contact = opts.saveContact && this.contact;

    this.contactPromise
      .catch(() => {})
      .then(() => {
        contact ||= this.contact;
        this.request(Endpoint.ACTION, {
          key,
          ...contact,
          parameter: {
            ...params,
            param_contact_id: contact.idContact,
          },
        });
      });
  }

  setIpressoContact({ idContact, typeContact } = {}) {
    this.contact = { idContact, typeContact };
  }

  createContact() {
    const { idContact, typeContact } = this.contact;

    if (idContact && typeContact) {
      return Promise.resolve();
    }

    return this.request(Endpoint.CREATE)
      .then((res) => this.setIpressoContact(res.data.data));
  }

  findContact({ email, ipressoId }) {
    if (!ipressoId) {
      return Promise.reject();
    }

    return this.request(Endpoint.FIND, {
      idContact: ipressoId,
      mail: email,
    }).then((res) => {
      if (this.isContactIncorrect()) {
        this.setIpressoContact(res.data.data);
      }

      if (this.contact.typeContact !== ContactType.ANONYMOUS || res.data.data?.typeContact !== ContactType.RECOGNIZED) {
        return;
      }

      return this.mergeContact(res.data.data);
    });
  }

  mergeContact({ idContact, typeContact } = {}) {
    return this.request(Endpoint.MERGE, { contacts: [this.contact, { idContact, typeContact }] })
      .then(() => this.setIpressoContact({ idContact, typeContact }));
  }

  subscriberSync({ isLogged, email, ipressoId }) {
    this.contactPromise = isLogged ? this.findContact({ email, ipressoId }) : this.createContact();
  }

  createApiClient(appId, baseURL, params = {}) {
    const client = axios.create({
      baseURL,
      headers: {
        appId,
        'Content-Type': 'application/json',
      },
    });

    if (params.withAuth) {
      client.interceptors.request.use((config) => {
        const { token } = this.subscriber?.authToken || {};

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      });
    }

    return client;
  }

  isContactIncorrect() {
    return !this.contact.typeContact || !this.contact.idContact;
  }
}
